export const preventScrollOnParent = (e: React.WheelEvent): void => {
  e.stopPropagation();

  const { clientHeight, scrollTop, scrollHeight } = e.currentTarget;

  const shouldStopScroll =
    e.deltaY > 0 ? clientHeight + scrollTop === scrollHeight : scrollTop === 0;

  if (shouldStopScroll) {
    e.preventDefault();
  }
};
